<template>
  <div class="registerCardStyle">
    <UserBase
      :title="$t('user.user_password-setting')"
      :isShowToLogin="isShowToLogin"
    >
      <template #default>
        <div class="caution">
          {{ $t('user.user_input-new-password') }}
        </div>
        <v-row no-gutters class="py-2" justify="center" align-content="center">
          <v-col cols="10">
            <v-text-field
              v-model="userInfo.password1"
              :placeholder="$t('common.input_password')"
              :rules="validations.password1.rules"
              type="password"
              outlined
              dense
              :hide-details="!isShowErrorMessage('password1')"
              height="36"
              @blur="validations.password1.isInput = true"
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row no-gutters class="py-2" justify="center" align-content="center">
          <v-col cols="10">
            <v-text-field
              v-model="userInfo.password2"
              :placeholder="$t('user.user_password-for-confirm')"
              :rules="validations.password2.rules"
              type="password"
              outlined
              dense
              :hide-details="!isShowErrorMessage('password2')"
              height="36"
              @blur="validations.password2.isInput = true"
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-spacer class="pa-3" />
        <v-row no-gutters justify="center" align-content="center">
          <v-col cols="10">
            <NormalButton
              :text="$t('common.input_order-send')"
              height="50px"
              :disabled="isDisabled"
              @click="execResetPassword"
            />
          </v-col>
        </v-row>
      </template>
    </UserBase>
    <TermsDialog v-model="dialogParams" />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { UserBase } from '@/components/layouts'
import { NormalButton } from '@/components/items'
import { TermsDialog } from '@/components/layouts/Dialogs'

const regexp =
  /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/ // eslint-disable-line

export default {
  components: {
    UserBase,
    NormalButton,
    TermsDialog
  },
  data: () => {
    return {
      userInfo: {
        token: '',
        email: '',
        password1: '',
        password2: ''
      },
      dialogParams: {
        dialog: false,
        type: 'TERMS'
      },
      isFetching: false,
      validations: {
        mail: { isInput: false, rules: [] },
        password1: { isInput: false, rules: [] },
        password2: { isInput: false, rules: [] }
      }
    }
  },
  created() {
    const { token, email } = this.$route.query
    this.userInfo.token = token
    this.userInfo.email = email
    this.makeValidationRules()
  },
  computed: {
    isDisabled() {
      return (
        this.isFetching ||
        !this.userInfo.password1 ||
        !this.userInfo.password2 ||
        this.isShowErrorMessage('password1') ||
        this.isShowErrorMessage('password2')
      )
    },
    isShowToLogin() {
      return this.$route.query.token ? true : false
    }
  },
  methods: {
    ...mapActions('User', [
      'resetPassword',
      'setPasswordAfterInvite',
      'changePassword'
    ]),
    startFetch() {
      this.isFetching = true
    },
    stopFetch() {
      this.isFetching = false
    },
    async execResetPassword() {
      this.isFetching = true
      let isSucceed
      if (!this.$route.query.token) {
        isSucceed = await this.changePassword({
          password: this.userInfo.password1,
          password_confirmation: this.userInfo.password2
        })
      } else if (
        this.$route.query.from &&
        this.$route.query.from === 'invite'
      ) {
        isSucceed = await this.setPasswordAfterInvite({
          token: this.userInfo.token,
          password: this.userInfo.password1,
          password_confirmation: this.userInfo.password2
        })
      } else {
        isSucceed = await this.resetPassword({
          token: this.userInfo.token,
          email: this.userInfo.email,
          password: this.userInfo.password1,
          password_confirmation: this.userInfo.password2
        })
      }

      this.isFetching = false
      if (isSucceed) {
        this.$router.push({
          name: 'reset-password.success'
        })
      }
    },
    checkPasswordVarid(str) {
      const ratz = /[a-z]/,
        rAtZ = /[A-Z]/,
        r0t9 = /[0-9]/
      return (
        ratz.test(str) && rAtZ.test(str) && r0t9.test(str) && str.length > 7
      )
    },
    checkPasswordMatch() {
      return this.userInfo.password1 === this.userInfo.password2
    },
    isShowErrorMessage(type) {
      const targetRule = this.validations[type]
      switch (type) {
        case 'password1':
          return (
            targetRule.isInput &&
            (!this.userInfo.password1 ||
              !this.checkPasswordVarid(this.userInfo.password1))
          )
        case 'password2':
          return (
            targetRule.isInput &&
            (!this.userInfo.password2 ||
              !this.checkPasswordVarid(this.userInfo.password2) ||
              !this.checkPasswordMatch())
          )
        default:
          return
      }
    },
    makeValidationRules() {
      this.validations.password1.rules = [
        (v) => v.length > 0 || this.$t('common.common_is-required'),
        (v) =>
          this.checkPasswordVarid(v) || this.$t('common.common_is-password')
      ]
      this.validations.password2.rules = [
        (v) => v.length > 0 || this.$t('common.common_is-required'),
        (v) =>
          this.checkPasswordVarid(v) || this.$t('common.common_is-password'),
        () =>
          this.checkPasswordMatch() ||
          this.$t('common.common_confirm-password-different')
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.registerCardStyle {
  .terms {
    font-size: 12px !important;
  }
}

.caution {
  width: 100%;
  text-align: center;
  white-space: pre-wrap;
  color: #666666;
  line-height: 30px;
  margin-bottom: 20px;
}
</style>
